<template>
    <ion-header class="ion-no-border lg:py-6 px-6" :style="headerCss">
        <ion-toolbar class="" :style="toolbarCss">
            <ion-buttons slot="start" class="flex-1">
                <ion-back-button v-show="showBackButton" :icon="caretBack" text="retour"
                                 :default-href="backDefaultHref"></ion-back-button>
            </ion-buttons>
            <ion-searchbar v-if="showSearchbar" class="main-search" @click="onClickSearch"
                           placeholder="Rechercher un souvenir ici..."></ion-searchbar>
            <ion-img v-if="showLogo" class="logo" src="assets/images/logo-hm.png" @click="goHome"></ion-img>
            <ion-buttons slot="end" v-show="showButtons" class="flex-1 ion-justify-content-end">
                <button-icon v-if="showHome" @click="goHome" icon-url="assets/images/home_icon.png">
                    Accueil
                </button-icon>
                <button-icon v-if="showAccount" icon-url="assets/images/account_icon.png" @click="goAccount">
                    Mon compte
                </button-icon>
                <button-icon v-if="showHelp" icon-url="assets/images/aide_icon.png">
                    Aide
                </button-icon>
            </ion-buttons>
        </ion-toolbar>
    </ion-header>
</template>

<script>
import { IonHeader, IonToolbar, IonButtons, IonBackButton, IonImg, IonSearchbar, modalController } from '@ionic/vue';
import { defineComponent } from 'vue';
import ButtonIcon from "@/components/ButtonIcon";
import { caretBack } from "ionicons/icons";
import { goToUserHouse } from "@/services/RoutingService";
import ModalSearch from "@/components/Modal/ModalSearch.vue";

export default defineComponent({
    name: "NavBar",
    components: {
        ButtonIcon, IonSearchbar,
        IonHeader, IonToolbar, IonButtons, IonBackButton, IonImg,
    },
    props: {
        backDefaultHref: String,
        showBackButton: {
            type: Boolean,
            default: true,
        },
        showSearchbar: {
            type: Boolean,
            default: false,
        },
        showLogo: {
            type: Boolean,
            default: true,
        },
        showButtons: {
            type: Boolean,
            default: true,
        },
        showHelp: Boolean,
        showHome: Boolean,
        showAccount: Boolean,
        backgroundColor: {
            type: String,
            default: 'white' // white||transparent
        },
    },
    data() {
        return {
            caretBack,
            searchModal: null,
        }
    },
    computed: {
        headerCss() {
            let css = {};
            if (this.backgroundColor === 'white') {
                css.backgroundColor = '#fff';

            }
            else if (this.backgroundColor === 'transparent') {
                css.backgroundColor = 'transparent';
                css.position = 'absolute';
                css.top = '0';
            }
            return css;
        },
        toolbarCss() {
            return {
                '--background': this.backgroundColor === 'white' ? '#fff' : 'transparent',
            }
        }
    },
    methods: {
        goAccount: function () {
            if (this.$route.params.house) {
                this.$router.push('/house/' + this.$route.params.house + '/account')
            }
            else {
                this.$router.push('/account');

            }
        },
        goHome: function () {
            goToUserHouse(this.$router, this.$store.getters.getUser, this.$route.params.house);
        },

        async onClickSearch() {
            if (!this.searchModal) {
                await this.openSearchModal();
            }
            else {
                this.closeSearchModal();
            }
        },

        async openSearchModal() {
            this.searchModal = await modalController.create({
                component: ModalSearch,
                componentProps: {
                    searchQuery: this.searchQuery
                },
                breakpoints: [0, 0.5, 1],
                initialBreakpoint: 1,
            });

            await this.searchModal.present();

            await this.searchModal.onDidDismiss();
            this.searchModal = null;
        },

        closeSearchModal() {
            if (this.searchModal) {
                this.searchModal.dismiss();
                this.searchModal = null;
            }
        },
    }
})
</script>

<style lang="scss">
ion-toolbar {
    --background: transparent;

    .logo {
        height: 80px;
    }

    ion-buttons {
        min-width: 90px;
    }

    .buttons-last-slot {
        ion-img {
            height: 100%;
        }
    }

    ion-back-button {
        --background: var(--ion-color-primary);
        --border-radius: 22px;
        --color: #fff;
        --padding-end: 22px;
        --padding-start: 12px;
        --icon-font-size: 22px;
        --icon-margin-end: 6px;
        font-weight: bold;
    }

    ion-searchbar.main-search {
        padding-top: 6px;
        --background: #fff;
        --border-radius: 30px;
        --box-shadow: 0px 0px 0px 3px var(--ion-color-primary);
        --icon-color: var(--ion-color-primary);

        .searchbar-input {
            padding-inline-start: 40px !important;
            @apply text-sm;
        }

        .searchbar-search-icon {
            left: 12px;
        }

    }
}

</style>
